// @flow
export { default } from './MainMobileHead';



// WEBPACK FOOTER //
// ./src/components/main/MainMobileHead/index.js